export const controlAnchor = (key) => `theme-control-${key}`;
export const scrollToControl = (key) => { var _a; return (_a = document.getElementById(controlAnchor(key))) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
